import { memo } from "react";
import { useBreakpoints } from "@narmi/design_system";

import MobileCardSelector from "./MobileCardSelector";
import DesktopCardSelector from "./DesktopCardSelector";

export interface CardSelectorProps {
  cardId?: API.CardId;
  cards: API.Card[];
  onChange: (id: API.CardId) => void;
}

const CardSelector = ({ cardId, cards, onChange }: CardSelectorProps) => {
  const { m } = useBreakpoints();

  if (!cardId) {
    return null;
  }

  if (!m) {
    return (
      <MobileCardSelector cardId={cardId} cards={cards} onChange={onChange} />
    );
  }
  return (
    <DesktopCardSelector cardId={cardId} cards={cards} onChange={onChange} />
  );
};

export default memo(CardSelector);
